import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
  Button,
  CircularProgress,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import GridOnIcon from "@mui/icons-material/GridOn";
import ListIcon from "@mui/icons-material/List";
import PublishIcon from "@mui/icons-material/Publish";
import GetAppIcon from "@mui/icons-material/GetApp";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const WorkflowDropdown = ({
  workflows,
  view,
  setView,
  navigate,
  upload,
  submitLoading,
  importFiles,
  exportAllWorkflows,
  isCloud,
  setLoadWorkflowsModalOpen,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <div style={{ flex: 1, textAlign: "right" }}>
      <IconButton onClick={handleOpen} color="inherit">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        <MenuItem
          onClick={() => {
            navigate("/workflows/debug");
            handleClose();
          }}
          disabled={workflows.length === 0}
        >
          <ListItemIcon>
            <QueryStatsIcon />
          </ListItemIcon>
          <ListItemText primary="Explore Workflow Runs" />
        </MenuItem>

        {view === "list" && (
          <MenuItem
            onClick={() => {
              localStorage.setItem("view", "grid");
              setView("grid");
              handleClose();
            }}
          >
            <ListItemIcon>
              <GridOnIcon />
            </ListItemIcon>
            <ListItemText primary="Grid View" />
          </MenuItem>
        )}
        {view === "grid" && (
          <MenuItem
            onClick={() => {
              localStorage.setItem("view", "list");
              setView("list");
              handleClose();
            }}
          >
            <ListItemIcon>
              <ListIcon />
            </ListItemIcon>
            <ListItemText primary="List View" />
          </MenuItem>
        )}

        <MenuItem
          onClick={() => {
            upload.click();
            handleClose();
          }}
        >
          <ListItemIcon>
            {submitLoading ? (
              <CircularProgress color="secondary" size={20} />
            ) : (
              <PublishIcon />
            )}
          </ListItemIcon>
          <ListItemText primary="Import Workflows" />
        </MenuItem>

        {workflows.length > 0 && (
          <MenuItem
            disabled={isCloud}
            onClick={() => {
              exportAllWorkflows(workflows);
              handleClose();
            }}
          >
            <ListItemIcon>
              <GetAppIcon />
            </ListItemIcon>
            <ListItemText primary={`Download All (${workflows.length})`} />
          </MenuItem>
        )}

        {!isCloud && (
          <MenuItem
            onClick={() => {
              setLoadWorkflowsModalOpen(true);
              handleClose();
            }}
          >
            <ListItemIcon>
              <CloudDownloadIcon />
            </ListItemIcon>
            <ListItemText primary="Import to Argus SOAR" />
          </MenuItem>
        )}
      </Menu>

      {/* Hidden file input */}
      <input
        hidden
        type="file"
        multiple
        ref={(ref) => (upload = ref)}
        onChange={importFiles}
      />
    </div>
  );
};

export default WorkflowDropdown;
